import React from 'react';

export default function StatsCard({ label, value, color, subtext, trend }) {
  return (
    <div className="stat-card">
      <div className="stat-label">{label}</div>
      <div className={`stat-value ${color}`}>
        {typeof value === 'number' ? value.toLocaleString() : value}
      </div>
      {subtext && (
        <div className={`stat-sub ${trend ? `trend-${trend}` : ''}`}>
          {trend === 'up' && '↑ '}
          {trend === 'down' && '↓ '}
          {subtext}
        </div>
      )}
    </div>
  );
}
